import React, { Component, Fragment } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATE_EDIT_PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import {
  UNSAVED_MESSAGE,
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
} from 'Common/Constants';
import {
  NewEditPhysicalEnum,
  SiteStatusEnum,
} from 'Common/Constants/Enumeration/PhysicalEnum';
import { FilterEnum, CreateEditPhysicalEnum, ItemEnum } from 'Common/FieldEnum';
import { resetForm } from 'State/forms/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as FilterSelectors from 'State/filters/selectors';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { ReportGeneration } from 'Common/ObjectHelper';

import { actions } from './../../state/actions';
import CreateEditPhysicalComponent from '../../components/createEditPhysical/CreateEditPhysical';
import { filterDataSource } from '../../helper';
import * as Selectors from '../../state/CreateEditPhysical/selectors';

class CreateEditPhysicalContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    physicalDT: PropTypes.string,
    site: PropTypes.string,
    physicalItemsInfo: PropTypes.array,

    physicalItemsData: PropTypes.array.isRequired,
    selectedPhysicalDetail: PropTypes.object,
    warningMessage: PropTypes.object,
    siteWarningDataLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsStorageLocationData: PropTypes.array.isRequired,
  };

  static defaultProps = {
    physicalDT: moment()
      .endOf('month')
      .format(DATE_FORMAT_FOR_UI),
    site: SiteStatusEnum.EMPTY,
    physicalItemsInfo: [],
    selectedPhysicalDetail: null,
    warningMessage: null,
    siteWarningDataLoadingError: null,
  };

  state = {
    accordionActiveIndex: 0,
    filterValues: {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
      [FilterEnum.GroupId_Location]: 0,
    },
    showUnsavedFiltersModal: false,
    showUnsavedSiteDateModal: false,
    showSiteWarningCheckModal: false,
    showDialog: false,
    SiteAndDeliveryDate: {
      newValue: null,
      previousValue: null,
      field: '',
    },
    minDate: moment()
      .subtract(10, 'year')
      .endOf('month'),
    maxDate: moment()
      .add(10, 'year')
      .endOf('month'),
  };

  componentDidUpdate(prevProps) {
    const { physicalItemsInfo, physicalItemsData, warningMessage } = this.props;
    const {
      showUnsavedFiltersModal,
      showUnsavedSiteDateModal,
      showSiteWarningCheckModal,
      showDialog,
    } = this.state;
    if (
      !_.isEmpty(prevProps.physicalItemsData) &&
      !_.isEmpty(physicalItemsData) &&
      !_.isEqual(prevProps.physicalItemsData, physicalItemsData)
    ) {
      filterDataSource(
        physicalItemsInfo,
        physicalItemsData,
        this.props.change,
        [CreateEditPhysicalEnum.PhysicalItemsInfo]
      );
    }
    if (
      showUnsavedFiltersModal ||
      showUnsavedSiteDateModal ||
      showSiteWarningCheckModal ||
      showDialog
    ) {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title:
          showSiteWarningCheckModal || showDialog
            ? 'Warning !'
            : 'Un-saved changes detected',
        question:
          showSiteWarningCheckModal && warningMessage.Data.Message
            ? warningMessage.Data.Message
            : showDialog
              ? 'Do you want to continue?'
              : UNSAVED_MESSAGE,
        yesCallback: () => {
          showUnsavedFiltersModal
            ? this.handleUnsavedFilterDialog(true)
            : showSiteWarningCheckModal
              ? this.printOpenTransactionReport(true)
              : showDialog
                ? this.handleWarningCheckDialog(true)
                : this.handleUnsavedSiteDateDialog(true);
        },
        noCallback: () => {
          showUnsavedFiltersModal
            ? this.handleUnsavedFilterDialog(false)
            : showSiteWarningCheckModal
              ? this.printOpenTransactionReport(false)
              : showDialog
                ? this.handleWarningCheckDialog(false)
                : this.handleUnsavedSiteDateDialog(false);
        },
      });
    }
  }

  printOpenTransactionReport = result => {
    const { warningMessage } = this.props;
    if (result) {
      if (warningMessage.Data.OpenTransactionReport) {
        ReportGeneration(
          warningMessage.Data.OpenTransactionReport,
          'Open Transaction Report'
        );
      }
    }
    this.setState({ showSiteWarningCheckModal: false, showDialog: true });
  };

  onChangeOfSiteAndDate = (event, newValue, previousValue, field) => {
    const { site } = this.props;
    if (
      newValue === previousValue ||
      (site === SiteStatusEnum.EMPTY &&
        field === CreateEditPhysicalEnum.PhysicalDT) ||
      (field === CreateEditPhysicalEnum.Site &&
        newValue === SiteStatusEnum.EMPTY) ||
      !field
    ) {
      return;
    }
    if (
      newValue !== previousValue &&
      previousValue !== NewEditPhysicalEnum.NEW &&
      this.props.physicalItemsInfo.length
    ) {
      this.setState({
        showUnsavedSiteDateModal: true,
        SiteAndDeliveryDate: {
          newValue,
          previousValue,
          field,
        },
      });
    } else {
      this.setState({
        SiteAndDeliveryDate: {
          newValue,
          previousValue,
          field,
        },
      });
      this.handleOnSiteAndDeliveryDateChange({
        newValue,
        previousValue,
        field,
      });
    }
  };
  clearFilters = () => {
    this.setState({
      showUnsavedFiltersModal: true,
    });
  };

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.props.clearPhysicalInfoGridData();
      this.handleClearFilters();
    } else {
      this.setState({ showUnsavedFiltersModal: false });
    }
  }

  handleChange = (e, values) => {
    this.setState({ filterValues: values });
  };

  handleUnsavedSiteDateDialog = result => {
    if (result) {
      this.setState({ showUnsavedSiteDateModal: false });
      this.handleOnSiteAndDeliveryDateChange();
    } else {
      const { previousValue, field } = this.state.SiteAndDeliveryDate;
      field === CreateEditPhysicalEnum.Site
        ? this.props.change([CreateEditPhysicalEnum.Site], previousValue)
        : this.props.change([CreateEditPhysicalEnum.PhysicalDT], previousValue);
      this.setState({ showUnsavedSiteDateModal: false });
    }
  };

  handleWarningCheckDialog(result) {
    if (result) {
      const {
        site,
        physicalDT,
        physicalItemsInfo,
        isLoadOnHandClicked,
      } = this.props;
      let tempSiteId = site;
      let physicalDate = physicalDT;

      if (tempSiteId !== SiteStatusEnum.EMPTY && physicalDate) {
        const filtersOptions = {
          SiteId: tempSiteId,
          DateTo: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
          DateFrom: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
        };
        this.props
          .getPhysicalItems(
            filtersOptions,
            true,
            physicalItemsInfo,
            isLoadOnHandClicked
          )
          .then(() => this.getSelectedItems());
        this.props.setIsLoadOnHandClicked(false);
      } else {
        this.props.emptyItemList();
      }
      this.setState({ showDialog: false });
    } else {
      const { previousValue, field } = this.state.SiteAndDeliveryDate;
      const { physicalDT } = this.props;
      field === CreateEditPhysicalEnum.Site
        ? this.props.change([CreateEditPhysicalEnum.Site], previousValue)
        : this.props.change([CreateEditPhysicalEnum.PhysicalDT], previousValue);
      this.setState({ showDialog: false });
      let previousSite = field === CreateEditPhysicalEnum.Site && previousValue;
      if (
        previousSite &&
        previousSite.length &&
        previousSite !== GenericEnum.ZeroString
      ) {
        this.props.change([CreateEditPhysicalEnum.PhysicalDT], physicalDT);
      }
    }
    this.props.clearSiteWarningData();
  }

  handleOnSiteAndDeliveryDateChange = obj => {
    const { newValue, field } = obj ? obj : this.state.SiteAndDeliveryDate;
    const {
      site,
      physicalDT,
      physicalItemsInfo,
      isLoadOnHandClicked,
      PhysicalId,
    } = this.props;
    let tempSiteId = site;
    let physicalDate = physicalDT;
    if (field === CreateEditPhysicalEnum.Site) {
      tempSiteId = newValue;
    } else if (field === CreateEditPhysicalEnum.PhysicalDT) {
      physicalDate = newValue;
    } else {
      return;
    }
    const model = {
      [CreateEditPhysicalEnum.SiteId]: tempSiteId,
      [CreateEditPhysicalEnum.PhysicalDT]: moment(
        physicalDate,
        DATE_FORMAT_FOR_UI
      ).format(DATE_FORMAT_FOR_SERVER),
      [CreateEditPhysicalEnum.SaveOption]: 0,
      [CreateEditPhysicalEnum.PhysicalId]: PhysicalId,
    };
    this.props.getSiteWarningData(model).then(() => {
      const {
        warningMessage,
        siteWarningDataLoadingError,
        clearSiteWarningDataError,
      } = this.props;
      if (warningMessage) {
        if (warningMessage.Title === TitleEnum.Warning) {
          if (warningMessage.Data.Message) {
            this.setState({
              showSiteWarningCheckModal: true,
            });
          }
        } else if (warningMessage.Title === TitleEnum.Success) {
          let selectedDate = moment(warningMessage.Data.PhysicalDate).format(
            DATE_FORMAT_FOR_UI
          );
          if (tempSiteId !== SiteStatusEnum.EMPTY && physicalDate) {
            const filtersOptions = {
              SiteId: tempSiteId,
              DateTo: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
              DateFrom: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
            };
            if (!siteWarningDataLoadingError) {
              this.props
                .getPhysicalItems(
                  filtersOptions,
                  true,
                  physicalItemsInfo,
                  isLoadOnHandClicked
                )
                .then(() => this.getSelectedItems());
            } else {
              clearSiteWarningDataError();
              this.props.emptyItemList();
            }
            this.props.setIsLoadOnHandClicked(false);
          } else {
            this.props.emptyItemList();
          }
          this.setState({
            minDate: moment(warningMessage.Data.PhysicalDate)
              .subtract(10, 'year')
              .endOf('month'),
            maxDate: moment(warningMessage.Data.PhysicalDate)
              .add(10, 'year')
              .endOf('month'),
          });
          this.props.change([CreateEditPhysicalEnum.PhysicalDT], selectedDate);
        }
      } else {
        if (tempSiteId !== SiteStatusEnum.EMPTY && physicalDate) {
          const filtersOptions = {
            SiteId: tempSiteId,
            DateTo: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
            DateFrom: moment(physicalDate).format(DATE_FORMAT_FOR_SERVER),
          };
          if (!siteWarningDataLoadingError) {
            this.props
              .getPhysicalItems(
                filtersOptions,
                true,
                physicalItemsInfo,
                isLoadOnHandClicked
              )
              .then(() => this.getSelectedItems());
          } else {
            clearSiteWarningDataError();
            this.props.emptyItemList();
          }
          this.props.setIsLoadOnHandClicked(false);
        } else {
          this.props.emptyItemList();
        }
      }
    });
  };

  onLoadOnHandClick = () => {
    this.props.setIsLoadOnHandClicked(true);
    const { site, physicalDT, isLoadOnHandClicked } = this.props;
    const filtersOptions = {
      SiteId: site,
      DateTo: moment(physicalDT).format(DATE_FORMAT_FOR_SERVER),
      DateFrom: moment(physicalDT).format(DATE_FORMAT_FOR_SERVER),
    };
    this.props.getOnHandItems(filtersOptions).then(() => {
      const { physicalOnHandDetail } = this.props;
      if (physicalOnHandDetail) {
        this.props
          .getPhysicalItems(
            filtersOptions,
            true,
            physicalOnHandDetail[CreateEditPhysicalEnum.PhysicalItems],
            isLoadOnHandClicked
          )
          .then(() => this.getSelectedItems());
      }
    });
  };

  handleClearFilters = () => {
    const {
      IsNewEdit,
      getPhysicalDetail,
      PhysicalId,
      getPhysicalItems,
      isLoadOnHandClicked,
    } = this.props;

    let filterValues = {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
      [FilterEnum.GroupId_Location]: 0,
    };
    this.setState({
      filtered: [],
      filterValues,
      showUnsavedFiltersModal: false,
    });
    this.props.resetForm(CREATE_EDIT_PHYSICAL_FORM_NAME);
    if (IsNewEdit !== NewEditPhysicalEnum.NEW) {
      getPhysicalDetail(PhysicalId).then(() => {
        const { selectedPhysicalDetail } = this.props;
        const filtersOptions = {
          SiteId: selectedPhysicalDetail[CreateEditPhysicalEnum.SiteId],
          PhysicalDate: moment(
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalDT]
          ).format(DATE_FORMAT_FOR_SERVER),
        };
        getPhysicalItems(
          filtersOptions,
          true,
          selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems],
          isLoadOnHandClicked
        ).then(() => this.getSelectedItems());
      });
      this.props.setIsLoadOnHandClicked(false);
    } else {
      this.props.emptyItemList();
    }
  };
  handleChangeAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionActiveIndex } = this.state;
    let newIndex = accordionActiveIndex === index ? -1 : index;

    this.setState({
      accordionActiveIndex: newIndex,
    });
  };

  getFilteredData = (gridFilterValues, itemDetails) => {
    return Object.keys(gridFilterValues).length > 0
      ? _.filter(itemDetails, gridFilterValues)
      : itemDetails;
  };

  getSelectedItems = () => {
    if (this.props.physicalItemsInfo && this.props.physicalItemsInfo.length) {
      let usageList = [];
      this.props.physicalItemsData.forEach(item => {
        _.some(this.props.physicalItemsInfo, obj => {
          if (item[ItemEnum.ItemCode] === obj[ItemEnum.ItemCode]) {
            usageList.push(obj);
            return true;
          }
        });
      });
      this.props.setModifiedPhysicalItems(usageList);
    }
  };

  render() {
    const {
      isDisabled,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsStorageLocationData,
      fetchPhysicalItems,
      physicalItemsData,
      site,
      IsNewEdit,
      resetPageOnDataChange,
      onResetPageOnDataChange,
      isLoadOnHandClicked,
      fetchSiteWarningDataLoading,
    } = this.props;
    const { filterValues } = this.state;

    const filterValuesData = {};
    _.map(filterValues, function(value, key, items) {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });

    let newData = [];
    const storageLocationFilterId = String(
      filterValuesData[FilterEnum.GroupId_Location]
    );
    delete filterValuesData[FilterEnum.GroupId_Location];
    if (+storageLocationFilterId) {
      newData = this.getFilteredData(filterValuesData, physicalItemsData);
      newData = _.filter(newData, item => {
        if (Array.isArray(item[CreateEditPhysicalEnum.StorageLocationIds])) {
          return item[CreateEditPhysicalEnum.StorageLocationIds].includes(
            storageLocationFilterId
          );
        }
      });
    } else {
      newData = this.getFilteredData(filterValuesData, physicalItemsData);
    }
    return (
      <Fragment>
        <CreateEditPhysicalComponent
          isDisabled={isDisabled}
          onChangeOfSiteAndDate={this.onChangeOfSiteAndDate}
          assignItemsBidGroupData={assignItemsBidGroupData}
          assignItemsItemGroupData={assignItemsItemGroupData}
          assignItemsStorageLocationData={assignItemsStorageLocationData}
          clearFilters={this.clearFilters}
          handleChange={this.handleChange}
          filterValues={filterValues}
          fetchPhysicalItems={fetchPhysicalItems}
          physicalItemsData={newData}
          onLoadOnHandClick={this.onLoadOnHandClick}
          selectedSite={site}
          isLoadOnHandClicked={isLoadOnHandClicked}
          IsNewEdit={IsNewEdit}
          accordionActiveIndex={this.state.accordionActiveIndex}
          handleChangeAccordion={this.handleChangeAccordion}
          minDate={this.state.minDate}
          maxDate={this.state.maxDate}
          resetPageOnDataChange={resetPageOnDataChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
          fetchSiteWarningDataLoading={fetchSiteWarningDataLoading}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_PHYSICAL_FORM_NAME);
const mapStateToProps = state => {
  return {
    physicalDT: selector(state, [CreateEditPhysicalEnum.PhysicalDT]),
    site: selector(state, [CreateEditPhysicalEnum.Site]),
    physicalItemsInfo: selector(state, [
      CreateEditPhysicalEnum.PhysicalItemsInfo,
    ]),

    physicalItemsData: Selectors.getPhysicalItems(state),
    selectedPhysicalDetail: Selectors.getSelectedPhysicalDetail(state),
    warningMessage: Selectors.getSiteWarningCheck(state),
    siteWarningDataLoadingError: Selectors.getSiteWarningDataLoadingError(
      state
    ),
    fetchSiteWarningDataLoading: Selectors.getFetchSiteWarningDataLoading(
      state
    ),

    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    assignItemsStorageLocationData: FilterSelectors.selectStorageLocationData(
      state
    ),
  };
};

CreateEditPhysicalContainer = reduxForm({
  form: CREATE_EDIT_PHYSICAL_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(CreateEditPhysicalContainer);

const mapDispatchToProps = {
  ...actions,
  resetForm,
  setYesNoDialogProps,
};

export const CreateEditPhysical = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditPhysicalContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/containers/createEditPhysical/CreateEditPhysical.js